export default "__VITE_ASSET__By7Z57L9__"